export const themesStylesAccelix = {
  brandBlue: "rgb(12, 122, 92)",
  brandRed: "rgb(179, 32, 35)",
  brandYellow: "rgb(244, 167, 0)",
  brandGrey: "rgb(84, 106, 20)",
  primary: "rgb(12, 122, 192)",
  secondary: "rgb(84, 106, 120)",
  warning: "rgb(244, 167, 0)",
  danger: "rgb(179, 32, 35)",
  fontMono: "'Courier', monospace",
  fontSans: "'Source Sans Pro', 'Arial', sans-serif",
  fontSerif: "'Bree Serif', 'Times', serif",
  baseFontColor: "rgb(84, 106, 120)",
  baseFontFamily: "'Source Sans Pro', 'Arial', sans-serif",
  baseFontSize: "16px",
  fontNormal: 400,
  fontSemibold: 600,
  fontBold: 700,
  baseLineHeight: 1.5,
  headings: "6 5 4 3 2 1",
  baseBorder: "1px solid rgb(84, 106, 120)",
  baseRadius: "0.25rem",
  baseBoxShadow: "rgba(42, 53, 60, 0.2) 0 0 5px",
  measBlue: "#5582ba"
};

export default themesStylesAccelix;
